module.exports = require("@web3auth/no-modal");